import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'mfp-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true
    }
  ]
})
export class InputComponent implements ControlValueAccessor {
  @Input() view = 'agent';
  @Input() label = '';
  @Input() name = '';
  @Input() type: 'text' | 'number' | 'email' | 'password' = 'text';
  @Input() placeholder = '';
  @Input() required = false;
  @Input() readonly = false;
  @Input() disabled = false;
  @Input() success = false;
  @Input() error = false;
  @Input() helper = '';
  @Input() mask: string | undefined = '';

  private innerValue: string | number = '';

  constructor() {}

  // ControlValueAccessor
  private onChangeCallback = (_: string | number) => {};
  private onTouchCallback = () => {};

  get value(): string | number {
    return this.innerValue;
  }

  set value(value: string | number) {
    if (value !== this.innerValue) {
      this.innerValue = value;
      this.onChangeCallback(value);
      this.onTouchCallback();
    }
  }

  writeValue(value: string | number): void {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  registerOnChange(fn: (_: string | number) => void): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouchCallback = fn;
  }

  setDisabledState(state: boolean): void {
    this.disabled = state;
  }
}
